import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import log from './modules/log'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import settings from './modules/settings'
import user from './modules/user'
import cache from './modules/cache'
import getters from './getters'
import imGroup from './modules/imGroup'
import bellNotify from './modules/bellNotify'
import uiCustom from './modules/uiCustom'
import dialogStatus from './modules/dialogStatus'
import frontEndPlugin from './modules/frontEndPlugin'
import destinationBusiness from './modules/destinationBusiness'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    log,
    permission,
    tagsView,
    settings,
    user,
    cache,
    imGroup,
    bellNotify,
    uiCustom,
    dialogStatus,
    frontEndPlugin,
    destinationBusiness
  },
  getters
})

export default store
